import { render } from "./live.sessions.widget.vue?vue&type=template&id=2450bb02"
import script from "./live.sessions.widget.vue?vue&type=script&lang=js"
export * from "./live.sessions.widget.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__